module.exports = __webpack_public_path__ + "img/IWG_200.eb9716ae.png";